/*
 * Copyright 2022, TeamDev. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Redistribution and use in source and/or binary forms, with or without
 * modification, must retain the above copyright notice and the following
 * disclaimer.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypedMessage = exports.TypeUrl = exports.Type = void 0;
exports.isProtobufMessage = isProtobufMessage;

var _googleProtobuf = require("google-protobuf");

var _base64Js = _interopRequireDefault(require("base64-js"));

var _wrappers_pb = require("../proto/google/protobuf/wrappers_pb");

var _timeUtils = require("./time-utils");

var _knownTypes = _interopRequireDefault(require("./known-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * Checks if the object extends {@link Message}.
 *
 * <p>The implementation doesn't use `instanceof` check and check on prototypes
 * since they may fail if different versions of the file are used at the same time
 * (e.g. bundled and the original one).
 *
 * @param object the object to check
 */
function isProtobufMessage(object) {
  return typeof object.constructor.typeUrl === 'function';
}
/**
 * A URL of a Protobuf type.
 *
 * Consists of the two parts separated with a slash. The first part is
 * the type URL prefix (for example, `type.googleapis.com`).
 * The second part is a fully-qualified Protobuf type name.
 *
 * @template <T>
 */


var TypeUrl = /*#__PURE__*/function () {
  /**
   * Creates a new instance of TypeUrl from the given string value.
   *
   * The value should be a valid type URL of format:
   * (typeUrlPrefix)/(typeName)
   *
   * @param {!string} value the type URL value
   */
  function TypeUrl(value) {
    _classCallCheck(this, TypeUrl);

    var urlParts = value.split('/');
    this._value = value;
    this._prefix = urlParts[0];
    this._name = urlParts[1];
  }
  /**
   * @return {string} part of the type URL before `/` specifying a namespace
   */


  _createClass(TypeUrl, [{
    key: "prefix",
    value: function prefix() {
      return this._prefix;
    }
    /**
     * @return {string} part of the type URL after `/` specifying the type name
     */

  }, {
    key: "name",
    value: function name() {
      return this._name;
    }
    /**
     * @return {!string} full type URL value formatted as `<prefix>/<name>` string
     */

  }, {
    key: "value",
    value: function value() {
      return this._value;
    }
  }]);

  return TypeUrl;
}();
/**
 * A type of the Protobuf message represented by its JavaScript class and type URL.
 *
 * @template <T>
 */


exports.TypeUrl = TypeUrl;

var Type = /*#__PURE__*/function () {
  /**
   * @param {!Class<T>} cls a class of the `Message` type is for
   * @param {!TypeUrl<T>} typeUrl a type URL of the `Message` type is for
   */
  function Type(cls, typeUrl) {
    _classCallCheck(this, Type);

    this._cls = cls;
    this._typeUrl = typeUrl;
  }
  /**
   * @return {!TypeUrl<T>} a type URL of a defined type
   */


  _createClass(Type, [{
    key: "url",
    value: function url() {
      return this._typeUrl;
    }
    /**
     * @return {!Class<T>} a JS class of a defined type
     */

  }, {
    key: "class",
    value: function _class() {
      return this._cls;
    }
    /**
     * A static factory for creating Type instances from `Message` class and type URL.
     *
     * @param {!Class<T>} cls a class of the `Message` type is for
     * @param {!string|TypeUrl<T>} typeUrl a type URL of the `Message` type is for
     *
     * @return {Type<T>} new Type instance
     */

  }], [{
    key: "of",
    value: function of(cls, typeUrl) {
      if (!(typeUrl instanceof TypeUrl)) {
        typeUrl = new TypeUrl(typeUrl);
      }

      return new Type(cls, typeUrl);
    }
    /**
     * Creates a new `Type` for the passed `Message` class.
     *
     * @param cls {!Class<T>} cls a class of the `Message`
     */

  }, {
    key: "forClass",
    value: function forClass(cls) {
      var typeUrl = _knownTypes["default"].typeUrlFor(cls);

      return this.of(cls, typeUrl);
    }
    /**
     * Creates a new `Type` for the passed `Message`.
     *
     * @param {!Message} message a Protobuf message
     */

  }, {
    key: "forMessage",
    value: function forMessage(message) {
      return this.forClass(message.constructor);
    }
  }]);

  return Type;
}(); // PRIMITIVE WRAPPERS


exports.Type = Type;
Type.STRING = Type.forClass(_wrappers_pb.StringValue);
Type.INT32 = Type.forClass(_wrappers_pb.Int32Value);
Type.UINT32 = Type.forClass(_wrappers_pb.UInt32Value);
Type.INT64 = Type.forClass(_wrappers_pb.Int64Value);
Type.UINT64 = Type.forClass(_wrappers_pb.UInt64Value);
Type.BOOL = Type.forClass(_wrappers_pb.BoolValue);
Type.DOUBLE = Type.forClass(_wrappers_pb.DoubleValue);
Type.FLOAT = Type.forClass(_wrappers_pb.FloatValue);
/**
 * A Protobuf message with a {@link TypeUrl}.
 *
 * The type URL specifies the type of the associated message.
 *
 * @template <T>
 */

var TypedMessage = /*#__PURE__*/function () {
  /**
   * Creates a new instance of TypedMessage from the given Protobuf message and
   * type URL.
   *
   * @param {!Message} message a Protobuf message
   * @param {!Type<T>} type a Protobuf type of the message
   */
  function TypedMessage(message, type) {
    _classCallCheck(this, TypedMessage);

    this.message = message;
    this.type = type;
  }
  /**
   * Creates a new instance of TypedMessage from the given Protobuf message.
   *
   * @param {!Message} message a Protobuf message
   * @returns {!TypedMessage} the created typed message
   */


  _createClass(TypedMessage, [{
    key: "toBase64",
    value:
    /**
     * Converts this message into a Base64-encoded byte string.
     *
     * @return the string representing this message
     */
    function toBase64() {
      var bytes = this.message.serializeBinary();
      return _base64Js["default"].fromByteArray(bytes);
    }
    /**
     * Creates a new `TypedMessage` wrapping a string.
     *
     * @param {!String} value a string value for `TypedMessage`
     * @return {TypedMessage<StringValue>} a new `TypedMessage` instance with provided value
     */

  }], [{
    key: "of",
    value: function of(message) {
      var type = Type.forMessage(message);
      return new TypedMessage(message, type);
    }
  }, {
    key: "string",
    value: function string(value) {
      var message = new _wrappers_pb.StringValue([value.toString()]);
      return TypedMessage.of(message);
    }
    /**
     * Creates a new `TypedMessage` with a 32-bit integer value.
     *
     * The number gets floored if the provided value contains a floating point.
     *
     * @param {!number|Number} value a number value for `TypedMessage`
     * @return {TypedMessage<Int32Value>} a new `TypedMessage` instance with provided value
     */

  }, {
    key: "int32",
    value: function int32(value) {
      var message = new _wrappers_pb.Int32Value([Math.floor(value.valueOf())]);
      return TypedMessage.of(message);
    }
    /**
     * Creates a new `TypedMessage` with an unsigned 32-bit integer value.
     *
     * The number gets floored if the provided value contains a floating point.
     *
     * @param {!number|Number} value a number value for `TypedMessage`
     * @return {TypedMessage<UInt32Value>} a new `TypedMessage` instance with provided value
     */

  }, {
    key: "uint32",
    value: function uint32(value) {
      var message = new _wrappers_pb.UInt32Value([Math.floor(value.valueOf())]);
      return TypedMessage.of(message);
    }
    /**
     * Creates a new `TypedMessage` with a 64-bit integer value.
     *
     * The number gets floored if the provided value contains a floating point.
     *
     * @param {!number|Number} value a number value for `TypedMessage`
     * @return {TypedMessage<Int64Value>} a new `TypedMessage` instance with provided value
     */

  }, {
    key: "int64",
    value: function int64(value) {
      var message = new _wrappers_pb.Int64Value([Math.floor(value.valueOf())]);
      return TypedMessage.of(message);
    }
    /**
     * Creates a new `TypedMessage` with an unsigned 64-bit integer value.
     *
     * The number gets floored if the provided value contains a floating point.
     *
     * @param {!number|Number} value a number value for `TypedMessage`
     * @return {TypedMessage<UInt64Value>} a new `TypedMessage` instance with provided value
     */

  }, {
    key: "uint64",
    value: function uint64(value) {
      var message = new _wrappers_pb.UInt64Value([Math.floor(value.valueOf())]);
      return TypedMessage.of(message);
    }
    /**
     * Creates a new `TypedMessage` with a float value.
     *
     * @param {!number|Number} value a number value for `TypedMessage`
     * @return {TypedMessage<FloatValue>} a new `TypedMessage` instance with provided value
     */

  }, {
    key: "float",
    value: function float(value) {
      var message = new _wrappers_pb.FloatValue([value.valueOf()]);
      return TypedMessage.of(message);
    }
    /**
     * Creates a new `TypedMessage` with a double value.
     *
     * @param {!number|Number} value a number value for `TypedMessage`
     * @return {TypedMessage<DoubleValue>} a new `TypedMessage` instance with provided value
     */

  }, {
    key: "double",
    value: function double(value) {
      var message = new _wrappers_pb.DoubleValue([value.valueOf()]);
      return TypedMessage.of(message);
    }
    /**
     * Creates a new `TypedMessage` with a boolean value.
     *
     * @param {!boolean|Boolean} value `true` or `false` value for the `TypedMessage`
     * @return {TypedMessage<BoolValue>} a new `TypedMessage` instance with provided value
     */

  }, {
    key: "bool",
    value: function bool(value) {
      var message = new _wrappers_pb.BoolValue([value]);
      return TypedMessage.of(message);
    }
    /**
     * Creates a new `TypedMessage` with a timestamp value composed from the given JavaScript date.
     *
     * @param {!Date} date a JavaScript `Date` value
     * @return {TypedMessage<Timestamp>} a new `TypedMessage` instance with provided value
     */

  }, {
    key: "timestamp",
    value: function timestamp(date) {
      var message = (0, _timeUtils.convertDateToTimestamp)(date);
      return TypedMessage.of(message);
    }
  }]);

  return TypedMessage;
}();

exports.TypedMessage = TypedMessage;
//# sourceMappingURL=typed-message.js.map